var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q-pa-md"},[_c('div',{staticClass:"text-center badge-titile",staticStyle:{"font-weight":"bold"},attrs:{"role":"heading","aria-level":"2"}},[_vm._v("Achieved Badges")]),_c('assign-badges')],1)}
var staticRenderFns = []

export { render, staticRenderFns }